import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  FormControlLabel,
  Checkbox,
  MenuItem,
} from "@mui/material";

const categories = ["Tablet", "Capsule", "Syrup", "Injection"];

export default function MedicineInsertionForm({ open, handleClose, initialData, handleSubmit }) {
  const [form, setForm] = useState(
    initialData || {
      name: "",
      description: "",
      category: "",
      manufacturer: "",
      price: "",
      discount_percentage: 0,
      stock: 0,
      image_url: "",
      prescription_required: false,
      is_active: true,
    }
  );

  function onChange(e) {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({
      ...f,
      [name]: type === "checkbox" ? checked : value,
    }));
  }

  function onSubmit(e) {
    e.preventDefault();
    handleSubmit(form);
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {initialData ? "Edit Medicine" : "Add Medicine"}
      </DialogTitle>
      <DialogContent>
        <form onSubmit={onSubmit}>
          <TextField
            label="Name"
            name="name"
            value={form.name}
            onChange={onChange}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="Description"
            name="description"
            value={form.description}
            onChange={onChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Category"
            name="category"
            select
            value={form.category}
            onChange={onChange}
            fullWidth
            margin="normal"
            required
          >
            {categories.map((cat) => (
              <MenuItem value={cat} key={cat}>{cat}</MenuItem>
            ))}
          </TextField>
          <TextField
            label="Manufacturer"
            name="manufacturer"
            value={form.manufacturer}
            onChange={onChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Price"
            name="price"
            type="number"
            value={form.price}
            onChange={onChange}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="Discount (%)"
            name="discount_percentage"
            type="number"
            value={form.discount_percentage}
            onChange={onChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Stock"
            name="stock"
            type="number"
            value={form.stock}
            onChange={onChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Image URL"
            name="image_url"
            value={form.image_url}
            onChange={onChange}
            fullWidth
            margin="normal"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={form.prescription_required}
                name="prescription_required"
                onChange={onChange}
              />
            }
            label="Prescription Required"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={form.is_active}
                name="is_active"
                onChange={onChange}
              />
            }
            label="Is Active"
          />
          <Button variant="contained" color="primary" type="submit">
            {initialData ? "Update" : "Add"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
